export enum CardStatus {
  normal = 'normal',
  warning = 'warning',
  urgent = 'urgent',
}
